export default {
  "authFailed": "Unable to finish portal setup",
  "authFailureHelp": "We could not restore the secure club session. Please retry or sign in again.",
  "signInAgain": "Sign in again",
  "retry": "Retry",
  "restoringAuth": "Restoring authentication...",
  "resolvingOrg": "Resolving organisation...",
  "loadingIdentity": "Loading identity...",
  "checkingClub": "Checking club details...",
  "clubNotFound": "Club not found",
  "invalidLink": "The link you followed is invalid.",
  "verifyFailed": "Unable to verify session",
  "verifyHelp": "Privana could not confirm your existing Auth0 session. Please sign in again to continue.",
  "signIn": "Sign In",
  "close": "Close",
  "broadcastResult": "SMS sent: {sent}. Failed: {failed}. Skipped: {skipped}.",
  "activeScope": "Active players currently in scope: {count}.",
  "inherit": "Club language",
  "saveFailed": "Unable to save language. Please try again."
};
